export const doubleChar = (value) => (value.length >= 2 ? value : "0" + value).slice(-2);

export const isOnMobileDevice=()=>{
  let prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  
  let matchMediaQuery = function(query) {
    return window.matchMedia(query).matches;
  };

  if ("ontouchstart" in window || navigator.maxTouchPoints) {
    return true;
  }

  let query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");

  return matchMediaQuery(query);
}

export const getDatePartsByProps = (stringTimeValue,hour12Format) => {
    const timeString = (stringTimeValue || "").toString().trim();

    // Return default values if timeString is empty or invalid
    if (!timeString || timeString.length < 5 || !timeString.includes(":")) {
        return {
            hour: hour12Format ? "12" : "00",
            minute: "00",
            amPm: "AM",
        };
    }

    const hourByProp = timeString.substring(0, 2);
    const minuteByProp = timeString.substring(3, 5);

    // Validate hour and minute are numeric
    const hourNum = parseInt(hourByProp, 10);
    const minuteNum = parseInt(minuteByProp, 10);

    if (isNaN(hourNum) || isNaN(minuteNum) || hourNum < 0 || hourNum > 23 || minuteNum < 0 || minuteNum > 59) {
        return {
            hour: hour12Format ? "12" : "00",
            minute: "00",
            amPm: "AM",
        };
    }

    const editHourByFormat = hour12Format ? (hourNum <= 12 ? hourNum : hourNum - 12) : hourNum;
    return {
        hour: parseInt(editHourByFormat) === 0 && hour12Format ? "12" : doubleChar(editHourByFormat),
        minute: doubleChar(minuteByProp),
        amPm: parseInt(editHourByFormat) === 0 && hour12Format ? "AM" : hourNum < 12 ? "AM" : "PM",
    };
};